import { render, staticRenderFns } from "./LaneSuggestions.vue?vue&type=template&id=ff8346ae&scoped=true&lang=html&"
import script from "./LaneSuggestions.vue?vue&type=script&lang=js&"
export * from "./LaneSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./LaneSuggestions.vue?vue&type=style&index=0&id=ff8346ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8346ae",
  null
  
)

export default component.exports